import React from 'react';
import {
  ButtonsContainer,
  TagsContainer,
  DivisionLine,
  FilterButton,
  FilterContainer,
  TagFilterButton,
  ResultsText
} from '../Styles/ReinforcementFilter';
import IconPresencial from '../../../../assets/icons/map-pin.svg';
import IconRemote from '../../../../assets/icons/reinforcement/IconRemote.svg';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import { Checkbox } from '@/presentation/components/Checkbox';

interface FilterProps {
  selected: string;
  setSelected: any; // CAMBIAR EL ANY
  selectModality: string;
  setSelectModality: any;
  numberOfResults: number;
  changeCheckbox: (checked?: boolean) => void;
}

const ReinforcementFilter = (props: FilterProps) => {
  const {
    selected,
    setSelected,
    selectModality,
    setSelectModality,
    numberOfResults,
    changeCheckbox
  } = props;

  const choseModality = (clickedModalityTag: string) => {
    if (clickedModalityTag === 'Aula') {
      if (selectModality !== 'P') setSelectModality('P');
      else setSelectModality('');
    } else if (clickedModalityTag === 'Zoom') {
      if (selectModality !== 'R') setSelectModality('R');
      else setSelectModality('');
    }
  };

  return (
    <FilterContainer>
      <ButtonsContainer>
        <FilterButton
          className={selected === 'Todos' ? 'clicked' : ''}
          onClick={() => {
            GoogleAnalytics.writeLog(
              'portal-services-filterAllReinforcements',
              'services'
            );
            setSelected('Todos');
          }}
        >
          Todos
        </FilterButton>
        <FilterButton
          className={selected === 'TUT' ? 'clicked' : ''}
          onClick={() => {
            GoogleAnalytics.writeLog(
              'portal-services-filterTutoringReinforcements',
              'services'
            );
            setSelected('TUT');
          }}
        >
          Tutorías
        </FilterButton>
        <FilterButton
          className={selected === 'TAL1' ? 'clicked' : ''}
          onClick={() => {
            GoogleAnalytics.writeLog(
              'portal-services-filterWorkshopsReinforcements',
              'services'
            );
            setSelected('TAL1');
          }}
        >
          Talleres
        </FilterButton>
      </ButtonsContainer>
      <TagsContainer>
        Filtrar por:{' '}
        <TagFilterButton
          className={selectModality === 'P' ? 'clicked' : ''}
          onClick={(e: any) => {
            GoogleAnalytics.writeLog(
              'portal-services-filterClassroomReinforcements',
              'services'
            );
            choseModality('Aula');
            e.currentTarget.blur();
          }}
        >
          <img src={IconPresencial} alt="Aula" />
          <span>Aula</span>
        </TagFilterButton>
        <TagFilterButton
          className={selectModality === 'R' ? 'clicked' : ''}
          onClick={(e: any) => {
            GoogleAnalytics.writeLog(
              'portal-services-filterZoomReinforcements',
              'services'
            );
            choseModality('Zoom');
            e.currentTarget.blur();
          }}
        >
          <img src={IconRemote} alt="Zoom" />
          <span>Zoom</span>
        </TagFilterButton>
      </TagsContainer>
      <div>
        <Checkbox
          onChange={changeCheckbox}
          label="Solo talleres y/o tutorías con vacantes disponibles"
        />
      </div>
      <DivisionLine />
      {numberOfResults ? (
        <>
          {numberOfResults > 1 ? (
            <ResultsText>{numberOfResults} resultados</ResultsText>
          ) : (
            <ResultsText>{numberOfResults} resultado</ResultsText>
          )}
        </>
      ) : (
        <></>
      )}
    </FilterContainer>
  );
};

export default ReinforcementFilter;
